'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Banner = _react2['default'].createClass({
    displayName: 'Banner',


    /**
     */

    ANIMATION_SPEED_MS: 400,

    /**
     */

    propTypes: {
        'bannerID': _react2['default'].PropTypes.any,
        'bannerText': _react2['default'].PropTypes.string,
        'bannerLink': _react2['default'].PropTypes.string,
        'display': _react2['default'].PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'bannerID': -1,
            'bannerText': '',
            'display': false
        };
    },
    getInitialState: function getInitialState() {
        var cookie = Cookie.get('hide_banner');
        var isDismissed = cookie != undefined ? cookie.split(',').some(function (e) {
            return e == this.props.bannerID;
        }, this) : false; // don't display if this specific banner was dismissed (not just any banner)
        return {
            'display': !isDismissed && this.props.display
        };
    },
    componentDidMount: function componentDidMount() {
        this.isMounted = true;
    },
    componentWillUnmount: function componentWillUnmount() {
        this.isMounted = false;
    },
    hide: function hide() {
        // set cookie to hide in the future
        var cookie = Cookie.get('hide_banner');
        cookie = cookie != undefined ? cookie + ',' + this.props.bannerID : this.props.bannerID; // store this banner's id in csv in the cookie
        Cookie.set('hide_banner', cookie);

        // hide now
        var self = this;
        $('.m-banner').animate({ opacity: 0 }, this.ANIMATION_SPEED_MS, function hideCallback() {
            if (this.isMounted) {
                self.setState({
                    'display': false
                });
            }
        });
    },
    render: function render() {
        var banner;
        var link;

        if (this.props.bannerLink !== null) {
            link = _react2['default'].createElement(
                'a',
                { className: 'm-banner--link', href: this.props.bannerLink, target: '_blank', rel: 'noopener noreferrer' },
                'LEARN MORE'
            );
        }

        if (this.state.display) {
            banner = _react2['default'].createElement(
                'div',
                { className: 'm-banner' },
                _react2['default'].createElement('img', { className: 'm-banner--notification-icon', src: require('./notification_icon@2x.png') }),
                _react2['default'].createElement(
                    'span',
                    { className: 'm-banner--text' },
                    this.props.bannerText
                ),
                link,
                _react2['default'].createElement(
                    'a',
                    { className: 'm-banner--dismiss', onClick: this.hide },
                    _react2['default'].createElement('img', { className: 'm-banner--dismiss-icon', src: require('./x@2x.png') })
                )
            );
        } else {
            banner = _react2['default'].createElement('div', { className: 'm-banner-placeholder' });
        }

        return banner;
    }
});

module.exports = Banner;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/banner.jsx
 ** module id = 724
 ** module chunks = 0 1
 **/